import { NOT_LISTED, seriesPatch, useElement } from "@/lib/element";

export function SeriesField({ row, idx, onPatch }) {
  const el = useElement();
  if (row.design?.root) {
    return row.series === "element" ? <p data-testid={`quote-item-series-design-${idx}`} className="text-xs font-semibold text-amber-600">Series: Element (set per unit in the designer)</p> : null;
  }
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid={`quote-item-series-${idx}`}>
      <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">Series</span>
      <div className="inline-flex rounded-[9px] bg-[rgba(118,118,128,0.12)] p-[2px]">
        {["standard", "element"].map((s) => (
          <button key={s} type="button" data-testid={`quote-item-series-${s}-${idx}`} onClick={() => row.series !== s && onPatch(seriesPatch(row, s, el))}
            className={`min-w-[84px] rounded-[7px] px-3 py-1 text-[13px] capitalize ${(row.series || "standard") === s ? "bg-white font-semibold text-black shadow-[0_3px_8px_rgba(0,0,0,0.12),0_3px_1px_rgba(0,0,0,0.04)]" : "font-medium text-black"}`}>{s}</button>
        ))}
      </div>
      {row.series === "element" && !row.element_rated && <span data-testid={`quote-item-element-not-listed-${idx}`} className="text-xs text-amber-600">{NOT_LISTED}</span>}
      {row.series === "element" && row.element_rated && <span className="font-mono-num text-xs text-slate-400">U {Number(row.u_value).toFixed(2)} · SHGC {Number(row.shgc).toFixed(2)}</span>}
    </div>
  );
}

export function SetAllSeries({ rows, onPatchAll }) {
  const el = useElement();
  if (!rows.length) return null;
  return (
    <div className="flex items-center gap-2" data-testid="set-all-series">
      <span className="text-xs text-slate-500">All lines:</span>
      {["element", "standard"].map((s) => (
        <button key={s} type="button" data-testid={`set-all-${s}-button`} onClick={() => onPatchAll((r) => (r.design?.root || (r.series || "standard") === s ? null : seriesPatch(r, s, el)))}
          className="rounded-full border border-slate-700 px-3 py-1 text-xs font-semibold text-slate-300 transition-colors hover:border-amber-500/60 hover:text-amber-600">Set all to {s === "element" ? "Element" : "Standard"}</button>
      ))}
    </div>
  );
}
